addEventListener("DOMContentLoaded", () => {
    /* open insta links in new tab */
    addEventListener("click", e => {
	    let a = e.target.closest('a');
	    if (a && a.hostname.includes('instagram.com')) {
		    e.preventDefault();
		    window.open(a.href, '_blank', 'noopener,noreferrer');
	    }
    });

	const targetNode = document.querySelector('.header-menu overflow-list')
	const observer = new MutationObserver(entries => {
  	entries.forEach(entry => {
    	if (entry.type === "attributes" && entry.attributeName === "slot" & entry.target.hasAttribute("slot")) {
      	entry.target.removeAttribute("slot");
    	}
		});
	});

	observer.observe(targetNode, { attributes: true, subtree: true });

	document.querySelectorAll('footer rte-formatter p')
		.forEach(block => block.textContent = block.textContent.replace(/\d{4}/, new Date().getFullYear()));
});